import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import i18n from '@gik/i18n';
import { translationKeys } from '@gik/homepage/i18n/en';
import { Animation, Button, Container, Image, Proportion } from '@gik/ui';
import { getAssetsUrl } from '@gik/core/utils/LinkUtils';
import { HomepageBadge, IHomepageBadgeProps } from '@gik/homepage/components/HomepageBadge/HomepageBadge';
import animationLargeScreen from '../../assets/img/header/header-slider.json';
import animationMobileScreen from '../../assets/img/header/header-slider-mobile.json';
import { navigateTo } from '@/utils/environment';
import { CreateClickedLocation, useCreateAnalyticsController } from '@gik/create/hooks/useCreateAnalytics';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/hooks/BreakpointHooks';

const badges: IHomepageBadgeProps[] = [
  {
    title: 'Calendar',
    icon: `${getAssetsUrl()}marketing/icons/calendar.png`,
    jumpTo: 'care-calendar',
  },
  {
    title: 'Wishlist',
    icon: `${getAssetsUrl()}marketing/icons/wishlist.png`,
    jumpTo: 'wishlist',
  },
  {
    title: 'Updates',
    icon: `${getAssetsUrl()}marketing/icons/updates.png`,
    jumpTo: 'updates',
  },
  {
    title: 'Donations',
    icon: `${getAssetsUrl()}marketing/icons/fundraising.png`,
    jumpTo: 'donations',
  },
];

const blockName = 'homepage-header';

export default function HomepageHeader() {
  const bem = bemBlock(blockName);
  const { trackCreateClicked } = useCreateAnalyticsController();

  const isSmDown = useBreakpoint(Breakpoint.SM_DOWN);

  function onCreateClicked() {
    trackCreateClicked(CreateClickedLocation.HOMEPAGE_TOP);
    navigateTo('/create');
  }

  return (
    <Container className={bem()} element="header">
      <div className={bem('animation-container')}>
        {isSmDown ? (
          <Animation
            data={animationMobileScreen}
            mode="looped"
            assetsPrepend={`${getAssetsUrl()}homepage/img/header/`}
          />
        ) : (
          <Animation
            data={animationLargeScreen}
            mode="looped"
            assetsPrepend={`${getAssetsUrl()}homepage/img/header/`}
          />
        )}
      </div>

      <div className={bem('content-wrapper')}>
        <section className={bem('copy')}>
          <h1 className={bem('title')}>{i18n.t(translationKeys.introTitle)}</h1>

          <p className={bem('subtitle')}>{i18n.t(translationKeys.introSubTitle)}</p>

          <Button
            className={bem('start-page-button')}
            onClick={onCreateClicked}
            variant="secondary"
            pill
            size="xl"
            uppercase={false}
          >
            {i18n.t(translationKeys.createPageCopy)}
          </Button>
        </section>

        <section className={bem('buttons')}>
          <Image
            className={bem('buttons-copy')}
            src={`${getAssetsUrl()}homepage/img/header/support-made-simple.png`}
            proportion={new Proportion(258, 38)}
            asBackground
          />

          <section className={bem('badges')}>
            {badges.map((badge, i) => (
              <HomepageBadge key={i} {...badge} />
            ))}
          </section>
        </section>
      </div>
    </Container>
  );
}
